import { AxiosResponse } from 'axios';
import { config } from '../config';
import axios from './axios';
import { API, CLIENT, REPLACEMENTS } from './endpoints';

const backendUrl: string = config.backendApiUrl;
const baseUrl = `${backendUrl}/${API}/${CLIENT}/${REPLACEMENTS}`;

export interface IReplacementWord {
  text: string;
  spaceBefore: boolean;
}

export interface ILocalReplacement {
  id: number,
  source: string;
  target: string;
}

export type LocalReplacements = ILocalReplacement[]

export interface INewReplacement {
  source: IReplacementWord[];
  target: IReplacementWord;
}

export interface IReplacement {
  id: number
  source: IReplacementWord[];
  target: IReplacementWord;
}

export type ReplacementsList = IReplacement[]

export const getReplacements = (): Promise<AxiosResponse<ReplacementsList>> => {
  return axios.get(baseUrl);
};

export const getReplacement = (id: number) => {
  return axios.get(`${baseUrl}/${id}`);
};

export const deleteReplacement = (id: number) => {
  return axios.delete(`${baseUrl}/${id}`);
};

export const tokenize = (input: string): IReplacementWord[] => {
  const regex = /(\s*)([A-Za-z0-9]+|[^\sA-Za-z0-9])/g;
  const tokens: IReplacementWord[] = [];
  let m: RegExpExecArray | null;

  while ((m = regex.exec(input)) !== null) {
    const [, spaces, tok] = m;
    tokens.push({
      text: tok,
      spaceBefore: spaces.length > 0
    });
  }

  return tokens;
}

export const postNewReplacement = (newReplacement: INewReplacement) => {
  return axios.post(`${baseUrl}`, newReplacement, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
};


export const patchReplacement = (newReplacement: Partial<ILocalReplacement>) => {
  return axios.patch(`${baseUrl}/${newReplacement.id}`, { source: newReplacement.source, target: newReplacement.target }, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
};
